
  


if($(window).width() > 768) {
    $(document).ready(function () {
      let hideTimer;
      $('.nav-link').on('mouseenter', function () {
        clearTimeout(hideTimer);
        const name = $(this).data('name');
        $('.custom-mega-menu').stop(true, true).fadeIn(200);
        $('.site-nav').hide();
        $('.site-nav[data-id="' + name + '"]').show();
      });
    
      $('.nav-link').on('mouseleave', function () {
        hideTimer = setTimeout(() => {
          $('.custom-mega-menu').fadeOut(200);
        }, 300);
      });
    
      $('.custom-mega-menu').on('mouseenter', function () {
        clearTimeout(hideTimer);
      });
    
      $('.custom-mega-menu').on('mouseleave', function () {
        $(this).fadeOut(200);
      });

      $(document).on('click','button.is-blank.shrink-menu.no-js-hidden',function(){
        console.log("IN")
      })
    });
}
else {
  $('a.no-style.nav-link').on('click', function (e) {
      const name = $(this).data('name');
      const $targetMenu = $('.site-nav[data-id="' + name + '"]');

      if ($targetMenu.length > 0) {
        e.preventDefault(); // Prevent link if it's just for menu open
        $('.custom-mega-menu').addClass('active');
        $('.site-nav').removeClass('active');
        $targetMenu.addClass('active');
        // DO NOT add 'open-menu' class to body here
      }
    });

    // Handle back icon click (also acts like close)
    $('.custom-mega-menu').on('click', '.lrtg', function () {
      $('.custom-mega-menu').removeClass('active');
      $('.site-nav').removeClass('active');
    });
    // Handle close icon click
    $('.custom-mega-menu').on('click', '.close-mega-menu', function () {
      $('.custom-mega-menu').removeClass('active');
      $('.site-nav').removeClass('active');
      document.body.classList.remove('open-menu');
    });
}

$(function () {
		  $(".frwrap").click(function () {
		    $(".open").not(this).removeClass("open").next().slideUp(300)
		    $(this).toggleClass("open").next().slideToggle(300)
		  });
});

document.addEventListener('click', function (e) {
  if (e.target.closest('.snap-close-wrpr')) {
    const popup = document.getElementById('sm-pop-up-model');
    if (popup) {
      popup.remove();
      document.body.style.removeProperty('overflow'); 
      document.documentElement.style.removeProperty('overflow');
    }
  }
});

document.querySelector('li.small-only.hamburger')?.addEventListener('click', function () {
  document.body.classList.add('open-menu');
});
// document.querySelector('button.shrink-menu')?.addEventListener('click', function () {
//   document.body.classList.remove('open-menu');
// });
 

 function equalHeightAll(selector) {
    let tallest = 0;

    const $elements = $(selector);

    // Reset height to auto first
    $elements.css('height', 'auto');

    // Calculate tallest height using .height() (content height only)
    $elements.each(function () {
      const elHeight = $(this).height();
      if (elHeight > tallest) {
        tallest = elHeight;
      }
    });

    // Set all to tallest content height
    $elements.height(tallest);
  }

  // Run on load and resize
  $(window).on('load resize', function () {
    equalHeightAll('.collection-with-video .collection-content .card-head');
  });